import Toast from 'components/Toast';
import http from 'utils/http';

/**
 *
 * @param url 接口地址
 * @param params 接口参数
 * @param fileName 文件名
 * @param fileSuffix 文件后缀
 * @param config 配置项
 */

declare global {
    interface Navigator {
        msSaveOrOpenBlob: any;
    }
}

async function downloadFile(url, params, fileName, fileSuffix, config?) {
    Toast.loading(true);

    try {
        const res = await http.get(url, {
            ...config,
            params,
            responseType: 'arraybuffer'
        });

        const name = `${fileName || 'download'}.${fileSuffix}`;
        const blob = new Blob([res as any], {
            type: 'application/octet-stream'
        });

        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, name);
        } else {
            const urlObj = window.URL.createObjectURL(blob);
            const ele = document.createElement('a');

            ele.href = urlObj;
            ele.download = name;

            document.querySelector('body')!.appendChild(ele);
            ele.click();

            setTimeout(() => {
                ele.remove();
                window.URL.revokeObjectURL(urlObj);
            }, 1000);
        }
    } catch (err) {
        Toast.show(err);
    }

    Toast.loading(false);
}

export default downloadFile;
